import { useNavigate } from "react-router-dom";
import { ADMIN_LOGIN } from "./routes";

/**
 * Clients came in through the landing page and have no business on the admin
 * login form, so send them back where they started. Read this before the
 * clearing below wipes it.
 * @return {string} Where to send the user once they are logged out
 */
const landingAfterLogout = () =>
  localStorage.getItem("role") === "Client" ? "/" : ADMIN_LOGIN;

/**
 * Utility function to handle user logout
 * Clears all authentication data and redirects to login page
 */
export const logout = () => {
  const destination = landingAfterLogout();

  // Clear all authentication data from localStorage
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("role");

  // Clear Apollo cache if available
  if (window.__APOLLO_CLIENT__) {
    window.__APOLLO_CLIENT__.clearStore();
  }

  window.location.href = destination;
};

/**
 * Hook version of logout for use in React components
 * @return {Function} Logout function
 */
export const useLogout = () => {
  const navigate = useNavigate();

  return () => {
    const destination = landingAfterLogout();

    // Clear all authentication data from localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("role");

    // Clear Apollo cache if available
    if (window.__APOLLO_CLIENT__) {
      window.__APOLLO_CLIENT__.clearStore();
    }

    navigate(destination, { replace: true });
  };
};
